import { useAppSelector } from '@hooks/reduxHooks';
import { $api } from '@service/RequestService';
import { Permissions } from '@utils/constants/permissions';
import { useQuery } from 'react-query';

import { eventListConstants, eventListModels } from '..';

export const useActivityLogs = () => {
  const permissions = useAppSelector(state => state?.userReducer?.user?.role?.permissions);
  const isActivityLogs = permissions?.includes(Permissions.PERMISSION_ACTIVITY_LOGS);

  return useQuery<eventListModels.IActivityLogTypes>({
    queryKey: [eventListConstants.queryKeys.ACTIVITY_LOGS],
    queryFn: async () => {
      const res = await $api.get('/v1/activity-logs');

      return res?.data?.data;
    },
    enabled: isActivityLogs
  });
};
